<template>
  <div>
    <Banner v-if=" banner && banner.content" :banner="banner" @on-showDialog="showDialog('BANNER')"/>
    <Float v-if=" flow && flow.content" :flow="flow" @on-showDialog="showDialog('FLOW')"/>
    <Follow v-model="showFollow" :follow="follow" /> 
  </div>
</template>

<script>
import Banner from './banner.vue'
import Float from './float.vue'
import Follow from './follow.vue'
import { mapActions } from 'vuex'

export default {
  props: {
    placeEnum: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showFollow: false,
      follow: {},
      banner: {
        content: '',
        guidPageFlag: '',
        guidButtonFlag: '',
        guidCloseFlag: '',
        guidText: '',
        guidBackgroundUrl: '',
        officeAccount: {
          code: '',
          type: ''
         
        },
        key: ''
      },
      flow: {
        content: '',
        guidPageFlag: '',
        guidButtonFlag: '',
        officeAccount: {
          code: '',
          type: ''
        },
        key: ''
      }
    }
  },
  components: {
    Banner,
    Float,
    Follow
  },
  mounted () {
    this.getGuideInfo()
  },
  methods: {
    ...mapActions('activities', ['apiMigration']),
    async getGuideInfo () {
      const { success, data } = await this.apiMigration({ placeEnum: this.placeEnum })
      if (success) {
        this.banner = data?.banner || {}
        this.flow = data?.flow || {}
      }
    },
    showDialog (TYPE) {
      if (TYPE === 'BANNER') {
        const wx = {
          guidButtonFlag: this.banner.guidButtonFlag,
          guidCloseFlag: this.banner.guidCloseFlag,
          guidText: this.banner.guidText,
          guidBackgroundUrl: this.banner.guidBackgroundUrl,
          ...this.banner?.officeAccount || {}
        }
        this.follow = wx
      } else {
        const wx = {
          guidButtonFlag: this.flow.guidButtonFlag,
          guidCloseFlag: this.flow.guidCloseFlag,
          guidText: this.flow.guidText,
          guidBackgroundUrl: this.flow.guidBackgroundUrl,
          ...this.flow?.officeAccount || {}
        }
        this.follow = wx
      }
      this.showFollow = true
    }
  }  
}
</script>
